"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCityEvent = void 0;
const trackCityEvent = (params) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "city_view",
        city: params.city,
        city_raw: params.cityRaw,
        source: params.source,
        resolution_status: params.resolutionStatus,
        lat: params.lat,
        lng: params.lng,
        place_id: params.placeId,
        session_type: params.sessionType,
    });
};
exports.trackCityEvent = trackCityEvent;
